import React, { useState, useEffect } from "react";
import logo from "./logo.png";
import "../Table/Invoice.css";
import {
  Box,
  Divider,
  Flex,
  Text,
  useToast
} from "@chakra-ui/react";

const InvoiceTemplate = ({ invoiceData }) => {
  const {
    companyName,
    companyAddress,
    brandRepName,
    brandRepEmail,
    creatorName,
    deliverables,
    paymentTerms,
    totalAmount,
    link,
    InvoiceNumber,
  } = invoiceData;

  const [currentDate, setCurrentDate] = useState("");

    const links = link.split(/[\s,;]+/).filter((link) => link.trim().length > 0);

  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toLocaleDateString("en-US");
    setCurrentDate(formattedDate);
  }, []);

  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(totalAmount);

  return (
    <Box className="invoice-container" width="100%">
      <Box className="invoice-content" maxWidth="800px" margin="0 auto" padding="20px">
        {/* Header */}
        <Flex 
          className="invoice-header" 
          justifyContent="space-between" 
          alignItems="center" 
          flexDirection={{ base: "column", md: "row" }}
          marginBottom="20px"
        >
          <Box className="company-info" textAlign={{ base: "center", md: "left" }} width={{ base: "100%", md: "auto" }}>
  <Flex alignItems="flex-end" justifyContent={{ base: "center", md: "flex-start" }} gap={2}>
    <img src={logo} alt="Company Logo" style={{ width: "60px", height: "auto" }} />
    <Text className="titlecm-tc">Creatives Matter LLC</Text>
  </Flex>
</Box>

          
          <Box className="invoice-title" textAlign={{ base: "center", md: "right" }} marginTop={{ base: "10px", md: "0" }}>
            <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>Invoice</h2>
          </Box>
        </Flex>

        {/* Invoice Details */}
        <Flex 
       className="invoice-details" 
  justifyContent="flex-start" 
  alignItems="center"
  flexDirection="row" 
  flexWrap="wrap"
  gap="20px"
  marginBottom="20px"
        >
          <Box className="invoice-number" marginBottom={{ base: "10px", md: "0" }}>
            
            <Flex alignItems="center">
              <Box width="4px" height="30px" marginRight="12px"  borderRight="2px solid black" />

              <Box className="label" fontWeight="bold" marginRight="8px">
                <h2>INVOICE#:</h2>
              </Box>
              <span>{InvoiceNumber}</span>
            </Flex>
          </Box>

          <Box className="invoice-date">
            <Flex alignItems="center">
 <Box width="4px" height="30px" marginRight="12px"  borderRight="2px solid black" />


              <Box className="label" fontWeight="bold" marginRight="8px">
                <h2>DATE ISSUED:</h2>
              </Box>
              <span>{currentDate}</span>
            </Flex>
          </Box>
        </Flex>

        {/* Customer Info */}
        <Box className="customer-details" marginBottom="20px" padding="15px" border="1px solid #e0e0e0" borderRadius="4px">
          <Box marginBottom="10px">
               <Flex alignItems="center">
            <h1 style={{ fontWeight: "bold", fontSize: "18px" }}>CUSTOMER DETAILS:</h1>
            <p>{companyName}</p></Flex>
          </Box>

          <Box marginBottom="10px">
            <Flex alignItems="center">
              <h3 style={{ fontWeight: "bold", minWidth: "80px" }}>Contact:</h3>
              <p>{brandRepName}</p>
            </Flex>
          </Box>

         <Box mb="10px">
           <Box  p="2">
             <Text as="span" fontWeight="bold">
               Company Address:
             </Text>{' '}
             <Text as="span" whiteSpace="pre-wrap">
               {companyAddress}
             </Text>
           </Box>
         </Box>

          <Box>
            <Flex alignItems="center">
              <h3 style={{ fontWeight: "bold", minWidth: "110px" }}>Email/Phone:</h3>
              <p>{brandRepEmail}</p>
            </Flex>
          </Box>
        </Box>

        {/* Campaign Table */}
       <Box className="campaign-table" marginBottom="20px" overflowX="auto">
  <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid black" }}>
    <thead>
      <tr style={{ borderBottom: "1px solid black", background: "black", color: "white" }}>
        <th
          style={{
            width: "35%",
            padding: "10px",
            textAlign: "left",
            border: "1px solid black",
          }}
        >
          Creator's Name
        </th>
        <th
          style={{
            padding: "10px",
            textAlign: "left",
            border: "1px solid black",
          }}
          colSpan="2"
        >
          Campaign Details
        </th>
      </tr>
    </thead>
    <tbody>
      <tr style={{ borderBottom: "1px solid black" }}>
        <td style={{ padding: "10px", verticalAlign: "top", border: "1px solid black" }}>
          <p>{creatorName}</p>
        </td>
        <td style={{ padding: "10px", border: "1px solid black" }} colSpan="2">
          <div style={{ fontSize: "14px", marginBottom: "8px" , letterSpacing: "0.3px",
          lineHeight: "1.5"}}>{deliverables}</div>
          {links.length > 0 && (
            <Flex wrap="wrap" gap="8px" marginTop="8px">
              {links.map((url, idx) => (
                <a
                  key={idx}
                  className="invoice-link"
                  href={/^https?:\/\//.test(url) ? url : `https://${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "14px",
                    color: "#0066cc",
                    textDecoration: "none",
                  }}
                >
                  {url}
                </a>
              ))}
            </Flex>
          )}
        </td>
      </tr>
      <tr>
        <td style={{ padding: "10px", border: "1px solid black" }}>
          <b style={{ display: "block", marginBottom: "5px" }}>Payment Terms:</b>
          <p>{paymentTerms}</p>
        </td>
        <td
          style={{
            padding: "10px",
            fontWeight: "bold",
            verticalAlign: "top",
            border: "1px solid black",
          }}
        >
          Total Amount
        </td>
        <td
          style={{
            padding: "10px",
            fontWeight: "bold",
            verticalAlign: "top",
            border: "1px solid black",
          }}
        >
          {formattedAmount}
        </td>
      </tr>
    </tbody>
  </table>
</Box>

        {/* Payment Info */}
        <Box className="payment-info">
  <Flex alignItems="center">
    <Box width="4px" height="30px" marginRight="12px" borderRight="2px solid black" />
    <h2
      className="heading-with-border"
      style={{
        fontSize: "18px",
        fontWeight: "bold",
        marginBottom: "20px",
        paddingBottom: "5px",
      }}
    >
      PAYMENT TO
    </h2>
  </Flex>

  <Box className="payment-details" padding="10px">
    <Flex marginBottom="8px">
      <span><strong>Bank of America:</strong> 100 North Tryon Street, Charlotte, NC 28202</span>
    </Flex>

    <Flex marginBottom="8px">
      <span><strong>Payee Name:</strong> Creatives Matter LLC</span>
    </Flex>

    <Flex marginBottom="8px">
      <span><strong>Account No (USD):</strong> 488119962570</span>
    </Flex>

    <Flex marginBottom="8px">
      <span><strong>Routing (ACH):</strong> 1110 00025</span>
    </Flex>

    <Flex marginBottom="8px">
      <span><strong>Wires (Domestic):</strong> 0260 09593</span>
    </Flex>

    <Flex marginBottom="8px">
      <span><strong>SWIFT (International/USD):</strong> BOFAUS3N</span>
    </Flex>

    <Flex marginBottom="8px">
      <span><strong>SWIFT (International/Non-USD):</strong> BOFAUS6S</span>
    </Flex>

    <Flex marginBottom="8px">
      <span><strong>Zelle Email:</strong> Michael@CreativesMatter.com</span>
    </Flex>

    <Flex marginBottom="8px">
      <span><strong>Paypal Email:</strong> Info@CreativesMatter.com</span>
    </Flex>
  </Box>
</Box>

      </Box>
    </Box>
  );
};

export default InvoiceTemplate;